module.exports = __webpack_public_path__ + "static/media/sow-section-8-banner.97239dea.svg";